import {
  CommentOutlined,
  FormatListBulletedRounded,
  StickyNote2Outlined,
  TrendingUpRounded,
} from "@mui/icons-material";
import { Divider, Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { ActionItemSummaryDto } from "src/http";
import { Avatar, AvatarGroup, DueDateIcon, isWhitespace } from "..";

interface IProps {
  actionItem: ActionItemSummaryDto;
  sx?: SxProps;
}

const ActionItemIcons = (props: IProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={0.25}
      divider={<Divider orientation="vertical" sx={{ height: "12px" }} />}
      sx={props.sx}
      alignItems="center"
    >
      {props.actionItem.owners.length > 0 && (
        <AvatarGroup
          max={2}
          sx={{
            "& .MuiAvatar-root": { width: 20, height: 20, fontSize: 12 },
          }}
          users={props.actionItem.owners}
          avatarComponent={(user) => <Avatar user={user} tooltip />}
        />
      )}

      {props.actionItem.note !== null && !isWhitespace(props.actionItem.note) && (
        <Tooltip title="Notes">
          <StickyNote2Outlined sx={{ color: theme.palette.grey[300] }} />
        </Tooltip>
      )}

      {props.actionItem.dueDate != null && <DueDateIcon dueDate={props.actionItem.dueDate} />}

      {props.actionItem.metricCount > 0 && (
        <Tooltip title="Metric">
          <TrendingUpRounded sx={{ color: theme.palette.grey[300] }} />
        </Tooltip>
      )}

      {props.actionItem.supportingItemsCount > 0 && (
        <Tooltip title="Supporting Items">
          <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
            <FormatListBulletedRounded sx={{ color: theme.palette.grey[300] }} />
            <Typography variant="caption">{props.actionItem.supportingItemsCount}</Typography>
          </Stack>
        </Tooltip>
      )}

      {props.actionItem.commentCount > 0 && (
        <Tooltip title="Comments">
          <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
            <CommentOutlined sx={{ color: theme.palette.grey[300] }} />
            <Typography variant="caption">{props.actionItem.commentCount}</Typography>
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};

export { ActionItemIcons };
